export default __webpack_public_path__ + "static/media/0.50a49eb6.png";